var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDairyFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#7DA9B3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24916 10.9238L9.2532 10.9065L9.25834 10.8893L10.7304 5.99885C10.7451 5.9414 10.7645 5.88514 10.7876 5.83065C10.4274 5.69035 10.1729 5.34875 10.1729 4.94945C10.1729 4.42493 10.6112 4 11.1517 4H15.0386C15.5793 4 16.0175 4.42493 16.0175 4.94921C16.0175 5.34851 15.7634 5.68988 15.4034 5.83018C15.4268 5.88478 15.446 5.94092 15.4607 5.99873L16.9327 10.8891L16.9378 10.9063L16.942 10.9237C17.2402 12.1714 17.209 13.1245 17.186 13.8206C17.1831 13.9134 17.18 14.001 17.1783 14.0829V19.4716C17.1783 20.9881 15.9057 22.2223 14.3416 22.2223H11.8495C10.2854 22.2223 9.01293 20.9881 9.01293 19.4716V13.8846L9.01134 13.8222C8.99102 13.0583 8.96593 12.1074 9.24916 10.9238Z",
    fill: "#7DA9B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0033 13.2578C10.0197 13.2637 10.0364 13.2683 10.0528 13.2737C10.1074 13.2921 10.4489 13.3845 10.4594 13.3868C10.5195 13.4001 11.1545 13.5361 11.718 13.4372C12.6877 13.267 13.5372 12.7263 14.4015 12.2986C15.062 11.9714 15.5918 12.0007 15.5918 12.0007C15.6548 12.0029 15.8397 12.0315 15.869 12.0386C16.052 13.0327 15.9935 13.785 15.9819 14.3288V19.1218C15.9819 20.1591 15.1311 21 14.0816 21H11.9113C10.8617 21 10.0109 20.1589 10.0109 19.1218V14.1558C10.0041 13.8836 9.99505 13.5857 10.0033 13.2578Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDairyFree);
export default __webpack_public_path__ + "static/media/icon-dairy-free.ddccd1e1c41f5c32c3c7d34092432f15.svg";
export { ForwardRef as ReactComponent };